
import {
  faCalendarDays,
  faClock,
  faCommentSms,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import "./Business_Hours.css";

function Business_Hours() {
  const businesshours = [
    {
      icon: faClock,
      title: "Monday - Saturday",
      time: "9:00 AM - 7:00 PM",
      status: "Open",
    },
    {
      icon: faCommentSms,
      title: "Sunday",
      time: "Closed",
      status: "Emergency SMS Only",
    },
    {
      icon: faCalendarDays,
      title: "Holidays",
      time: "Closed",
      status: "Emergency Support Active",
    },
  ];

  return (
    <section className="business_section">
      <Container>
        <div className="business_hours_content">

          <div className="business_hours_heading">
            <CommonHeading title="Business Hours" 
               description="   Our working hours and emergency support availability"/>
            {/* <p>
              Our working hours and emergency support availability
            </p> */}
          </div>

          <Row className="g-4">
            {businesshours.map((item, index) => (
              <Col lg={4} md={4} sm={12} key={index}>
                <div className="business_hours_card">

                  <div className="business_hours_icon">
                    <FontAwesomeIcon icon={item.icon} />
                  </div>

                  <div className="business_hours_details">
                    <h3>{item.title}</h3>

                    <div className="business_hours_time">
                      {item.time}
                    </div>

                    <span className="business_hours_status">
                      {item.status}
                    </span>
                  </div>

                </div>
              </Col>
            ))}
          </Row>

        </div>
      </Container>
    </section>
  );
}

export default Business_Hours;
